import _ from 'lodash';
import React, {PropTypes } from 'react';
import ErrorMessage from '../error-message/error-message';

import styles from './input-field-simple.scss';

class InputFieldSimple extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    changed: PropTypes.func.isRequired,

    showError: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isVisible: PropTypes.bool,
    blurred: PropTypes.func,
    errorMessage: PropTypes.string,
    element: PropTypes.func
  };

  constructor (props) {
    super(props);

    this.state = {
      value: this.props.value ? this.props.value : ''
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.value !== nextProps.value || this.state.value !== nextProps.value) {
      this.setState({value: nextProps.value});
    }
  }

  onChange (event) {
    event.preventDefault();
    const value = event.target.value;
    this.setState({value: value});
    this.props.changed(value);
  }

  onBlur (event) {
    event.preventDefault();
    const value = event.target.value;

    if (_.isFunction(this.props.blurred)) {
      this.props.blurred(value);
    }
  }

  getClasses (name, globalClasses = []) {
    let classes = styles[name];

    if (this.props.showError) {
      classes += ' ' + styles['is-error'];
    }

    if (!_.isEmpty(globalClasses)) {
      classes += ' ' + globalClasses.join(' ');
    }

    return classes;
  }

  render () {
    if (!this.props.isVisible) {
      return false;
    }
    return (
      <div className={this.getClasses('wrapper', ['form-row-item'])}>
        <label
          className={this.getClasses('label')}
          htmlFor={this.props.name}>
          {this.props.label}
        </label>

        <input
          ref={this.props.element}
          className={this.getClasses('input')}
          type={this.props.type}
          name={this.props.name}
          value={this.state.value}
          placeholder={this.props.placeholder}
          disabled={this.props.isDisabled}
          onChange={this.onChange}
          onBlur={this.onBlur} />
        <ErrorMessage show={this.props.showError} errorMessage={this.props.errorMessage} marginTop={15}/>
      </div>
    );
  }
}

export default InputFieldSimple;



/** WEBPACK FOOTER **
 ** ./src/components/input-field/input-field-simple.js
 **/